import { render, staticRenderFns } from "./uf_is_prp_not_analog.vue?vue&type=template&id=a4b6591a&scoped=true"
import script from "./uf_is_prp_not_analog.vue?vue&type=script&lang=js"
export * from "./uf_is_prp_not_analog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b6591a",
  null
  
)

export default component.exports